interface Store {
  [key: string]: {
    color: string;
    title: string;
    icon: string;
  };
}
export enum STORE_KEY {
  WANDERPRINTS = "great-family-shop.myshopify.com",
  VIOPAW = "xa80sh-rb.myshopify.com",
  "WDPS-US" = "wdp-us.myshopify.com",
  "TEST-STORE" = "by-test123.myshopify.com",
}

export const STORE: Store = new Proxy(
  {
    [STORE_KEY.WANDERPRINTS]: {
      title: "Wanderprints",
      icon: "https://wanderprints.com/cdn/shop/files/Favi_827af463-cb4b-4a2d-ab14-f43e55c152cf_180x180.png?v=1629008286",
      color: "#0c0c0c",
    },
    [STORE_KEY.VIOPAW]: {
      title: "VioPaw",
      icon: "https://viopaw.com/cdn/shop/files/Frame_1_1_180x180.png?v=1742984138",
      color: "#4d2b78",
    },
    [STORE_KEY["WDPS-US"]]: {
      title: "WDP US",
      icon: "https://wanderprints.com/cdn/shop/files/Logo_Wander_Prints_200x1000px.png?v=1751005820&width=512",
      color: "#4d2b78",
    },
    [STORE_KEY["TEST-STORE"]]: {
      title: "Test Store",
      icon: "https://wanderprints.com/cdn/shop/files/Logo_Wander_Prints_200x1000px.png?v=1751005820&width=512",
      color: "#000000",
    },
  },
  {
    get(target, prop: string) {
      return (
        target[prop as STORE_KEY] || {
          title: "Wanderprints",
          icon: "https://wanderprints.com/cdn/shop/files/Favi_827af463-cb4b-4a2d-ab14-f43e55c152cf_180x180.png?v=1629008286",
          color: "#0c0c0c",
        }
      );
    },
  },
);

export const CONSTANTS_KEYS = {
  SELECTED_STORE: "selectedStore",
  USER: "BYUser",
  AUTH_TOKEN: "authToken",
  REFRESH_TOKEN: "refreshToken",
};
